import React from 'react'
import { AvailabilityEvent } from '../../domain/Event'

interface Props {
    data: AvailabilityEvent
}
class Availability extends React.Component<Props> {
    public vendorLabels = {
        oh_dear: 'Oh Dear!',
        uptime_robot: 'UptimeRobot',
    }

    public render() {
        return (
            <div className="box event-box">
                <div className="box-body">
                    <div className="timeline-body">
                        <div className="row">
                            <div className="col-lg-1">
                                {this.props.data.vendor === 'oh_dear' ? <img width="75" height="75" src="/assets/img/ohdear2.png" /> : null}
                            </div>
                            <div className="col-lg-11">
                                <strong>{this.vendorLabels[this.props.data.vendor]}</strong> detected that the site{' '}
                                <strong>{this.props.data.url}</strong> (belonging to this application) is <strong>down</strong>.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Availability
